import request from "../services/requestService";
import * as apiServices from "../services/apiServices";

export const sendEmailNotificationAction = (
  requestMethod = request,
  params
) => {
  return requestMethod(apiServices.sendEmailApi(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("SignUp Failed", e.message);
    });
};

export const sendSmsNotificationAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.sendSmsApi(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("SignUp Failed", e.message);
    });
};
